import React from 'react'
import { Link } from 'react-router-dom'
const NavItem = () =>(
    <ul className="navbar-nav ml-auto">
        <li className="nav-item">
            <Link className="nav-link" to = "/">Inicio</Link>
        </li>
        <li className="nav-item">
            <Link className="nav-link" to="/clima">Clima</Link>
        </li>
        <li className="nav-item">
            <Link className="nav-link" to="/algoritmos">Algoritmos</Link>
        </li>
        <li className="nav-item">
            <Link className="nav-link" to="/escolares">Escolares</Link>
        </li>
        <li className="nav-item">
            <Link className="nav-link" to="/minijuegos">Minijuegos</Link>
        </li>
        <li className="nav-item">
            <Link className="nav-link" to="/electronica">Electrónica</Link>
        </li>
        <li className="nav-item">
            <Link className="nav-link" to="/animaciones">Animaciones</Link>
        </li>
        
    </ul>
    
)
export default NavItem

// <li className="nav-item dropdown">
//             <a className="nav-link dropdown-toggle" href = "/"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
//               Universidades Uruapan
//             </a>
//             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
//                 <Link className="dropdown-item" to="/universidades">Lista de universidades</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/mejorescarreras">Mejores carreras</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/testvocacional">Test vocacional</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/testaptitud">Test de aptitud</Link>
//             </div>
//         </li>
//         <li className="nav-item dropdown">
//             <a className="nav-link dropdown-toggle" href = "/"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
//                 Algoritmos
//             </a>
//             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
//                 <Link className="dropdown-item" to="/multiplicadorconstante">Multiplicador constante</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/convertirnumeros">Convertir números</Link>
//             </div>
//         </li>
//         <li className="nav-item dropdown">
//             <a className="nav-link dropdown-toggle" href = "/"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
//                 Juegos
//             </a>
//             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
//                 <Link className="dropdown-item" to="/snakegame">Snake game</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/shootergame">Shooter game</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/reflejos">Comprueba tus reflejos</Link>
//             </div>
//         </li>
//         <li className="nav-item dropdown">
//             <a className="nav-link dropdown-toggle" href = "/"  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
//                 Animaciones
//             </a>
//             <div className="dropdown-menu" aria-labelledby="navbarDropdown">
//                 <Link className="dropdown-item" to="/boton">Botón</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/relojdigital">Reloj digital</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/circulos">Círculos</Link>
//                 <div className="dropdown-divider"></div>
//                 <Link className="dropdown-item" to="/relojanalogico">Reloj analógico</Link>
//             </div>
//         </li>